import React from "react"
import Layout from "../component/layout"
export default () => (
  <Layout>
    <h1>My resume is that I'm sick as hell</h1>
  </Layout>
  )